import React from "react";

const LABELS = {
  hindu: "Hindu",
  buddhist: "Buddhist",
  christian: "Christian",
  sikh: "Sikh",
  jain: "Jain",
  sufi: "Sufi",
  zen: "Zen",
};

export default function TraditionTag({ tradition, className = "" }) {
  if (!tradition) return null;
  return (
    <span className={`tradition-tag ${className}`}>
      {LABELS[tradition] || tradition}
    </span>
  );
}
